module.exports = __webpack_public_path__ + "img/Intuit.f0667c4b.jpg";